import createAPI from "@/common/createApi.js"
/**
 * config: 接口参数，
 * vconfig: （自定义参数）{
 *  neverLoading: 是否显示loading
 * }
 */
export default {
  // 获取组列表
  getGroupList: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/groups`, "get", config),
  // 新建组
  addGroup: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/groups`, "post", config),
  // 删除组
  deleteGroup: (realmName, id, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/groups/${ id }`, "delete", config),
  //获取组详情
  getGroupInfo: (realmName, id, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/groups/${ id }`, "get", config),
  // 更新组信息 
  putGroupInfo: (realmName, id, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/groups/${ id }`, "put", config), 
  // 获取组成员信息
  getGroupUser: (realmName, id, config) =>
    createAPI(`/idaas/admin/realms/${ realmName }/groups/${ id }/members`, "get", config),
  // 获取组授权信息列表
  getGroupRoles: (realmName, id, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/groups/${ id }/clients/roles`, "get", config),
  // 获取组已授权的应用列表   
  getGroupHasGrantApps: (realmName, id, config) =>
    createAPI(`/idaas/admin/realms/${ realmName }/groups/${ id }/authed/clients`, "get", config),
  // 给组授权应用   
  putGroupmentAuthClients: (realmName, id, config) =>
    createAPI(`/idaas/admin/realms/${ realmName }/groups/${ id }/clients`, "put", config),
  // 获取组已授权的应用列表   
  putGroupAuthCliRoles: (realmName, gid, id, config) =>
    createAPI(`/idaas/admin/realms/${ realmName }/groups/${ gid }/clients/${ id }/roles`, "put", config),
}
